import React from 'react'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { PhoneCall, FileText, Video } from 'lucide-react'
const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Otomatik Mülakat Sistemi</h1>
            <p className="text-xl text-gray-500">
              Yazılı, sesli ve videolu otomatik mülakat sistemi ile adayları ve çalışanları
              değerlendirin
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 place-items-center">
            <div className="bg-gray-50 rounded-lg p-6 border max-w-full md:col-start-2">
              <h2 className="text-2xl text-center font-bold mb-4">Videolu Mülakat</h2>
              <p className="mb-6 text-center">
                Adayları video görüşmesi ile değerlendirin. Kamera erişimi ile mülakatı
                gerçekleştirin ve kopya çekme tespiti ile güvenli bir ortam sağlayın.
              </p>
              <Button asChild size="lg" className="w-full">
                <Link to="/video-interview">
                  <Video className="mr-2 h-5 w-5" />
                  Sınavı Başlat
                </Link>
              </Button>
            </div>
          </div>

          <div className="border-t pt-12 mt-12">
            <h2 className="text-2xl font-bold mb-6 text-center">Özellikler</h2>

            <div className="grid gap-6 md:grid-cols-3">
              <div className="p-4 border rounded-lg">
                <h3 className="font-bold mb-2">Çoklu Mülakat Formatları</h3>
                <p className="text-gray-600">
                  Yazılı, sözlü veya videolu mülakatlarla adayları değerlendirerek farklı
                  becerilerini ölçün.
                </p>
              </div>

              <div className="p-4 border rounded-lg">
                <h3 className="font-bold mb-2">Detaylı Raporlama</h3>
                <p className="text-gray-600">
                  Her soru için ayrıntılı istatistikler ve yanıt analizleri ile performansı ölçün.
                </p>
              </div>

              <div className="p-4 border rounded-lg">
                <h3 className="font-bold mb-2">Kopya Çekme Tespiti</h3>
                <p className="text-gray-600">
                  Videolu mülakatlarda kopya çekme davranışlarını tespit ederek mülakatların
                  güvenliğini sağlayın.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
export default Index
